import _classCallCheck from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _awaitAsyncGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _wrapAsyncGenerator from "/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { CUSTOM_DRAG_TYPE as $103790afe9474d1c$export$fd9f9fc120c5402d, DROP_OPERATION as $103790afe9474d1c$export$60b7b4bcf3903d8e, GENERIC_TYPE as $103790afe9474d1c$export$f8fc6581787339b3, NATIVE_DRAG_TYPES as $103790afe9474d1c$export$4a7729b856e9a690 } from "./constants.module.js";
import { useInteractionModality as $j62BV$useInteractionModality, getInteractionModality as $j62BV$getInteractionModality } from "@react-aria/interactions";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $7252cd45fc48c07c$export$dfdf5deeaf27473f = new WeakMap();
var $7252cd45fc48c07c$export$990fced5dfac2637 = Symbol();
function $7252cd45fc48c07c$export$3093291712f09a77(state) {
  var _$7252cd45fc48c07c$ex = $7252cd45fc48c07c$export$dfdf5deeaf27473f.get(state),
    id = _$7252cd45fc48c07c$ex.id;
  if (!id) throw new Error('Droppable item outside a droppable collection');
  return id;
}
function $7252cd45fc48c07c$export$7e397efd01d3db27(state) {
  var _$7252cd45fc48c07c$ex2 = $7252cd45fc48c07c$export$dfdf5deeaf27473f.get(state),
    ref = _$7252cd45fc48c07c$ex2.ref;
  if (!ref) throw new Error('Droppable item outside a droppable collection');
  return ref;
}
function $7252cd45fc48c07c$export$e1d41611756c6326(items) {
  var types = new Set();
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      for (var _i = 0, _Object$keys = Object.keys(item); _i < _Object$keys.length; _i++) {
        var type = _Object$keys[_i];
        types.add(type);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return types;
}
function $7252cd45fc48c07c$var$mapModality(modality) {
  if (!modality) modality = 'virtual';
  if (modality === 'pointer') modality = 'virtual';
  if (modality === 'virtual' && typeof window !== 'undefined' && 'ontouchstart' in window) modality = 'touch';
  return modality;
}
function $7252cd45fc48c07c$export$49bac5d6d4b352ea() {
  return $7252cd45fc48c07c$var$mapModality((0, $j62BV$useInteractionModality)());
}
function $7252cd45fc48c07c$export$1fb2158d224b542c() {
  return $7252cd45fc48c07c$var$mapModality((0, $j62BV$getInteractionModality)());
}
function $7252cd45fc48c07c$export$f9c1490890ddd063(dataTransfer, items) {
  // The data transfer API doesn't support more than one item of a given type at once.
  // In addition, only a small set of types are supported natively for transfer between applications.
  // We allow for both multiple items, as well as multiple representations of a single item.
  // In order to make our API work with the native API, we serialize all items to JSON and
  // store as a single native item. We only need to do this if there is more than one item
  // of the same type, or if an item has more than one representation. Otherwise the native
  // API is sufficient.
  //
  // The DataTransferItemList API also theoretically supports adding files, which would enable
  // dragging binary data out of the browser onto the user's desktop for example. Unfortunately,
  // this does not currently work in any browser, so it is not currently supported by our API.
  // See e.g. https://bugs.chromium.org/p/chromium/issues/detail?id=438479.
  var groupedByType = new Map();
  var needsCustomData = false;
  var customData = [];
  var _iterator2 = _createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var types = Object.keys(item);
      if (types.length > 1) needsCustomData = true;
      var dataByType = {};
      for (var _i2 = 0, _types = types; _i2 < _types.length; _i2++) {
        var type = _types[_i2];
        var typeItems = groupedByType.get(type);
        if (!typeItems) {
          typeItems = [];
          groupedByType.set(type, typeItems);
        } else needsCustomData = true;
        var _data = item[type];
        dataByType[type] = _data;
        typeItems.push(_data);
      }
      customData.push(dataByType);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var _iterator3 = _createForOfIteratorHelper(groupedByType),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _slicedToArray(_step3.value, 2),
        _type = _step3$value[0],
        _items = _step3$value[1];
      if ((0, $103790afe9474d1c$export$4a7729b856e9a690).has(_type)) {
        // Only one item of a given type can be set on a data transfer.
        // Join all of the items together separated by newlines.
        var _data2 = _items.join('\n');
        dataTransfer.items.add(_data2, _type);
      } else
        // Set data to the first item so we have access to the list of types.
        dataTransfer.items.add(_items[0], _type);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (needsCustomData) {
    var data = JSON.stringify(customData);
    dataTransfer.items.add(data, (0, $103790afe9474d1c$export$fd9f9fc120c5402d));
  }
}
var $7252cd45fc48c07c$export$7f04ce188c91447c = /*#__PURE__*/function () {
  _createClass($7252cd45fc48c07c$export$7f04ce188c91447c, [{
    key: "has",
    value: function has(type) {
      if (this.includesUnknownTypes || type === $7252cd45fc48c07c$export$990fced5dfac2637 && this.types.has((0, $103790afe9474d1c$export$f8fc6581787339b3))) return true;
      return typeof type === 'string' && this.types.has(type);
    }
  }]);
  function $7252cd45fc48c07c$export$7f04ce188c91447c(dataTransfer) {
    _classCallCheck(this, $7252cd45fc48c07c$export$7f04ce188c91447c);
    this.types = new Set();
    var hasFiles = false;
    var _iterator4 = _createForOfIteratorHelper(dataTransfer.items),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        if (item.type !== (0, $103790afe9474d1c$export$fd9f9fc120c5402d)) {
          if (item.kind === 'file') hasFiles = true;
          if (item.type) this.types.add(item.type);else
            // Files with unknown types or extensions that don't map to a known mime type
            // are sometimes exposed as an empty string by the browser. Map to a generic
            // mime type instead. Note that this could also be a directory as there's no
            // way to determine if something is a file or directory until drop.
            this.types.add((0, $103790afe9474d1c$export$f8fc6581787339b3));
        }
      }
      // In Safari, when dragging files, the dataTransfer.items list is empty, but dataTransfer.types contains "Files".
      // Unfortunately, this doesn't tell us what types of files the user is dragging, so we need to assume that any
      // type the user checks for is included. See https://bugs.webkit.org/show_bug.cgi?id=223517.
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    this.includesUnknownTypes = !hasFiles && dataTransfer.types.includes('Files');
  }
  return $7252cd45fc48c07c$export$7f04ce188c91447c;
}();
function $7252cd45fc48c07c$export$d9e760437831f8b3(dataTransfer) {
  var items = [];
  // If our custom drag type is available, use that. This is a JSON serialized
  // representation of all items in the drag, set when there are multiple items
  // of the same type, or an individual item has multiple representations.
  var hasCustomType = false;
  if (dataTransfer.types.includes((0, $103790afe9474d1c$export$fd9f9fc120c5402d))) try {
    var data = dataTransfer.getData((0, $103790afe9474d1c$export$fd9f9fc120c5402d));
    var parsed = JSON.parse(data);
    var _iterator5 = _createForOfIteratorHelper(parsed),
      _step5;
    try {
      var _loop = function _loop() {
        var item = _step5.value;
        items.push({
          kind: 'text',
          types: new Set(Object.keys(item)),
          getText: function getText(type) {
            return Promise.resolve(item[type]);
          }
        });
      };
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
    hasCustomType = true;
  } catch (e) {
    // ignore
  }
  // Otherwise, map native drag items to items of a single representation.
  if (!hasCustomType) {
    var stringItems = new Map();
    var _iterator6 = _createForOfIteratorHelper(dataTransfer.items),
      _step6;
    try {
      for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
        var item = _step6.value;
        if (item.kind === 'string')
          // The data for all formats must be read here because the data transfer gets
          // cleared out after the event handler finishes. If the item has an empty string
          // as a type, the mime type is unknown. Map to a generic mime type instead.
          stringItems.set(item.type || (0, $103790afe9474d1c$export$f8fc6581787339b3), dataTransfer.getData(item.type));else if (item.kind === 'file') {
          // Despite the name, webkitGetAsEntry is also implemented in Firefox and Edge.
          // In the future, we may use getAsFileSystemHandle instead, but that's currently
          // only implemented in Chrome.
          if (typeof item.webkitGetAsEntry === 'function') {
            var entry = item.webkitGetAsEntry();
            // eslint-disable-next-line max-depth
            if (!entry) continue;
            // eslint-disable-next-line max-depth
            if (entry.isFile) items.push($7252cd45fc48c07c$var$createFileItem(item.getAsFile()));else if (entry.isDirectory) items.push($7252cd45fc48c07c$var$createDirectoryItem(entry));
          } else
            // Assume it's a file.
            items.push($7252cd45fc48c07c$var$createFileItem(item.getAsFile()));
        }
      }
      // All string items are different representations of the same item. There's no way to have
      // multiple string items at once in the current DataTransfer API.
    } catch (err) {
      _iterator6.e(err);
    } finally {
      _iterator6.f();
    }
    if (stringItems.size > 0) items.push({
      kind: 'text',
      types: new Set(stringItems.keys()),
      getText: function getText(type) {
        return Promise.resolve(stringItems.get(type));
      }
    });
  }
  return items;
}
function $7252cd45fc48c07c$var$blobToString(blob) {
  if (typeof blob.text === 'function') return blob.text();
  // Safari doesn't have the Blob#text() method yet...
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsText(blob);
  });
}
function $7252cd45fc48c07c$var$createFileItem(file) {
  return {
    kind: 'file',
    type: file.type || (0, $103790afe9474d1c$export$f8fc6581787339b3),
    name: file.name,
    getText: function getText() {
      return $7252cd45fc48c07c$var$blobToString(file);
    },
    getFile: function getFile() {
      return Promise.resolve(file);
    }
  };
}
function $7252cd45fc48c07c$var$createDirectoryItem(entry) {
  return {
    kind: 'directory',
    name: entry.name,
    getEntries: function getEntries() {
      return $7252cd45fc48c07c$var$getEntries(entry);
    }
  };
}
function $7252cd45fc48c07c$var$getEntries(_x) {
  return _$7252cd45fc48c07c$var$getEntries.apply(this, arguments);
}
function _$7252cd45fc48c07c$var$getEntries() {
  _$7252cd45fc48c07c$var$getEntries = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(item) {
    var reader, entries, _iterator7, _step7, entry, file;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          reader = item.createReader(); // We must call readEntries repeatedly because there may be a limit to the
          // number of entries that are returned at once.
        case 1:
          _context.next = 3;
          return _awaitAsyncGenerator(new Promise(function (resolve, reject) {
            reader.readEntries(resolve, reject);
          }));
        case 3:
          entries = _context.sent;
          _iterator7 = _createForOfIteratorHelper(entries);
          _context.prev = 5;
          _iterator7.s();
        case 7:
          if ((_step7 = _iterator7.n()).done) {
            _context.next = 22;
            break;
          }
          entry = _step7.value;
          if (!entry.isFile) {
            _context.next = 17;
            break;
          }
          _context.next = 12;
          return _awaitAsyncGenerator($7252cd45fc48c07c$var$getEntryFile(entry));
        case 12:
          file = _context.sent;
          _context.next = 15;
          return $7252cd45fc48c07c$var$createFileItem(file);
        case 15:
          _context.next = 20;
          break;
        case 17:
          if (!entry.isDirectory) {
            _context.next = 20;
            break;
          }
          _context.next = 20;
          return $7252cd45fc48c07c$var$createDirectoryItem(entry);
        case 20:
          _context.next = 7;
          break;
        case 22:
          _context.next = 27;
          break;
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](5);
          _iterator7.e(_context.t0);
        case 27:
          _context.prev = 27;
          _iterator7.f();
          return _context.finish(27);
        case 30:
          if (entries.length > 0) {
            _context.next = 1;
            break;
          }
        case 31:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 24, 27, 30]]);
  }));
  return _$7252cd45fc48c07c$var$getEntries.apply(this, arguments);
}
function $7252cd45fc48c07c$var$getEntryFile(entry) {
  return new Promise(function (resolve, reject) {
    return entry.file(resolve, reject);
  });
}
function $7252cd45fc48c07c$export$97fd558bdc44bea1(dropItem) {
  return dropItem.kind === 'text';
}
function $7252cd45fc48c07c$export$a144e1752ebe0aa(dropItem) {
  return dropItem.kind === 'file';
}
function $7252cd45fc48c07c$export$2b40a62bdbe6b2b0(dropItem) {
  return dropItem.kind === 'directory';
}
var $7252cd45fc48c07c$export$6ca6700462636d0b = {
  draggingKeys: new Set()
};
function $7252cd45fc48c07c$export$f2be18a910c0caa6(ref) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.draggingCollectionRef = ref;
}
function $7252cd45fc48c07c$export$72cb63bdda528276(keys) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.draggingKeys = keys;
}
function $7252cd45fc48c07c$export$dac8db29d42db9a1(ref) {
  $7252cd45fc48c07c$export$6ca6700462636d0b.dropCollectionRef = ref;
}
function $7252cd45fc48c07c$export$70936501603e6c57() {
  $7252cd45fc48c07c$export$6ca6700462636d0b = {
    draggingKeys: new Set()
  };
}
function $7252cd45fc48c07c$export$6c10d32b362bfa5f(state) {
  $7252cd45fc48c07c$export$6ca6700462636d0b = state;
}
function $7252cd45fc48c07c$export$78bf638634500fa5(ref) {
  var _$7252cd45fc48c07c$ex3 = $7252cd45fc48c07c$export$6ca6700462636d0b,
    draggingCollectionRef = _$7252cd45fc48c07c$ex3.draggingCollectionRef,
    dropCollectionRef = _$7252cd45fc48c07c$ex3.dropCollectionRef;
  return (draggingCollectionRef === null || draggingCollectionRef === void 0 ? void 0 : draggingCollectionRef.current) != null && draggingCollectionRef.current === ((ref === null || ref === void 0 ? void 0 : ref.current) || (dropCollectionRef === null || dropCollectionRef === void 0 ? void 0 : dropCollectionRef.current));
}
var $7252cd45fc48c07c$export$8e6636520ac15722;
function $7252cd45fc48c07c$export$64f52ed7349ddb84(dropEffect) {
  $7252cd45fc48c07c$export$8e6636520ac15722 = dropEffect;
}
var $7252cd45fc48c07c$export$f0130eb70b6347b8 = (0, $103790afe9474d1c$export$60b7b4bcf3903d8e).none;
function $7252cd45fc48c07c$export$6539bc8c3a0a2d67(o) {
  $7252cd45fc48c07c$export$f0130eb70b6347b8 = o;
}
export { $7252cd45fc48c07c$export$dfdf5deeaf27473f as droppableCollectionMap, $7252cd45fc48c07c$export$990fced5dfac2637 as DIRECTORY_DRAG_TYPE, $7252cd45fc48c07c$export$3093291712f09a77 as getDroppableCollectionId, $7252cd45fc48c07c$export$7e397efd01d3db27 as getDroppableCollectionRef, $7252cd45fc48c07c$export$e1d41611756c6326 as getTypes, $7252cd45fc48c07c$export$49bac5d6d4b352ea as useDragModality, $7252cd45fc48c07c$export$1fb2158d224b542c as getDragModality, $7252cd45fc48c07c$export$f9c1490890ddd063 as writeToDataTransfer, $7252cd45fc48c07c$export$7f04ce188c91447c as DragTypes, $7252cd45fc48c07c$export$d9e760437831f8b3 as readFromDataTransfer, $7252cd45fc48c07c$export$97fd558bdc44bea1 as isTextDropItem, $7252cd45fc48c07c$export$a144e1752ebe0aa as isFileDropItem, $7252cd45fc48c07c$export$2b40a62bdbe6b2b0 as isDirectoryDropItem, $7252cd45fc48c07c$export$6ca6700462636d0b as globalDndState, $7252cd45fc48c07c$export$f2be18a910c0caa6 as setDraggingCollectionRef, $7252cd45fc48c07c$export$72cb63bdda528276 as setDraggingKeys, $7252cd45fc48c07c$export$dac8db29d42db9a1 as setDropCollectionRef, $7252cd45fc48c07c$export$70936501603e6c57 as clearGlobalDnDState, $7252cd45fc48c07c$export$6c10d32b362bfa5f as setGlobalDnDState, $7252cd45fc48c07c$export$78bf638634500fa5 as isInternalDropOperation, $7252cd45fc48c07c$export$8e6636520ac15722 as globalDropEffect, $7252cd45fc48c07c$export$64f52ed7349ddb84 as setGlobalDropEffect, $7252cd45fc48c07c$export$f0130eb70b6347b8 as globalAllowedDropOperations, $7252cd45fc48c07c$export$6539bc8c3a0a2d67 as setGlobalAllowedDropOperations };